import { createContext, useContext } from 'react';

// Readers can share overlay controls without importing editor layout machinery.
export const GraphEditorLayoutContext = createContext(null);
export const useGraphEditorLayout = () => useContext(GraphEditorLayoutContext);
